module.exports = __webpack_public_path__ + "static/media/veto_full.91813d06.jpg";